import React, {Component} from 'react';
import {Row, Col, Breadcrumb, Spin} from 'antd';
import {Link} from 'react-router-dom';
import moment from 'moment';
import '../../css/players.css';
import {api, app, config} from "../../app";

class PlayerRescueDetail extends Component {
    constructor(props) {
        super(props);
        const rescue_id = props.match.params.rescue_id;
        this.state = {
            data_loading: true
        };
        this.dataSource(rescue_id);
    }

    /**
     * 数据源
     */
    dataSource(rescue_id) {
        const _this = this;
        app.post(api.RescueDetails, {rescue_id}).then(({flag, data, msg}) => {
            if (flag === 1) {
                _this.setState({rescueInfo: data});
            } else {
                app.alert("网络服务忙~", "error");
            }
            _this.setState({data_loading: false});
        });
    }

    render() {
        const province = app.getData('link_province'), teamno = app.getData('link_teamno'),
            rescueInfo = this.state.rescueInfo || {},
            indexno = app.getData('link_indexno'), teamno1 = null, loading = this.state.data_loading;
        // rescueInfo.detail = `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus pronin sapien nunc accuan eget.`;
        // rescueInfo.images = "http://img3.imgtn.bdimg.com/it/u=1062609500,1970502157&fm=27&gp=0.jpg";
        return (
            <div className="ranks_content">
                <div className="r_page_title">救援列表<span>Rescue list</span></div>
                <Breadcrumb separator=">" className="r_right_breadcrumb">
                    <Breadcrumb.Item><Link to="/">首页</Link></Breadcrumb.Item>
                    {province ? (<Breadcrumb.Item><Link to={"/ranks/pro/" + province}>队伍列表</Link></Breadcrumb.Item>) : ''}
                    {teamno1 ? (
                        <Breadcrumb.Item><Link to={"/ranks/team/" + teamno1}>查看队伍</Link></Breadcrumb.Item>) : ''}
                    {teamno ? (
                        <Breadcrumb.Item><Link to={"/ranks/Players/" + teamno}>队员列表</Link></Breadcrumb.Item>) : ''}
                    {indexno ? (
                        <Breadcrumb.Item onClick={()=>{this.props.history.go(-2)}} className="pointer">个人页面</Breadcrumb.Item>) : ''}
                    {indexno ? (
                        <Breadcrumb.Item onClick={()=>{this.props.history.go(-1)}} className="pointer">救援列表</Breadcrumb.Item>) : ''}
                    <Breadcrumb.Item>救援详情</Breadcrumb.Item>
                </Breadcrumb>
                {
                    loading ? (<Row type="flex" align="middle" justify="center" className="data_loading"><Spin
                            tip="正在加载中..."></Spin></Row>)
                        : (<Row id="detail_all">
                            <h1 className="da_title">{rescueInfo.rescuename}</h1>
                            <Row className="da_info">
                                <Col span={12}
                                     className="dai_date">{rescueInfo.startdate ? moment(rescueInfo.startdate).format("YYYY-MM-DD HH:mm:ss") : "未知"}</Col>
                                <Col span={12} className="dai_ly">来源：{rescueInfo.team || "未知"}</Col>
                            </Row>
                            <Row className="da_detail">
                                <Col span={24} className="dad_text">{rescueInfo.detail}</Col>
                                <Col span={24} className="dad_img">{rescueInfo.images ?
                                    <img src={config.imgUrl + rescueInfo.images} width="80%"
                                         alt={rescueInfo.rescuename}/> : ''}
                                </Col>
                            </Row>
                        </Row>)
                }
            </div>
        );
    }
}

export default PlayerRescueDetail;



// WEBPACK FOOTER //
// ./src/routes/playerInfo/PlayerRescueDetail.jsx